<div class="personal-details-container">
  <!-- Lookup Type Selector -->
  <div class="lookup-form form">
    <mat-form-field appearance="outline">
      <input
        matInput
        type="text"
        placeholder="Select ID type"
        [value]="lookupType()"
        [matAutocomplete]="auto"
        (input)="lookupType.set($any($event.target).value)"
      />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
        @for (option of options; track option.text) {
        <mat-option [value]="option.text">{{ option.text }}</mat-option>
        }
      </mat-autocomplete>
      <mat-icon matSuffix>arrow_drop_down</mat-icon>
    </mat-form-field>
  </div>

  <!-- South African ID Form -->
  @if (southAfricanIdForm()) {
  <div class="id-form form" [formGroup]="southAfricanIdForm()!">
    <mat-form-field appearance="outline">
      <mat-label>Enter ID number</mat-label>
      <input
        required
        matInput
        type="text"
        pattern="[0-9]*"
        inputmode="numeric"
        placeholder="Enter ID number"
        formControlName="idNumber"
        maxlength="13"
        minlength="13"
        (keyup)="setDOBFromID()"
      />

      @if (southAfricanIdForm()?.get('idNumber')?.hasError('notValid') &&
      southAfricanIdForm()?.get('idNumber')?.touched) {
      <mat-error>Please enter a valid 13-digit ID number</mat-error>
      } @else if (southAfricanIdForm()?.get('idNumber')?.hasError('notAdult') &&
      southAfricanIdForm()?.get('idNumber')?.touched) {
      <mat-error>You need to be +18</mat-error>
      }
    </mat-form-field>
  </div>
  }

  <!-- Passport Form -->
  @if (passportForm()) {
  <div class="passport-form form" [formGroup]="passportForm()!">
    <ng-country-select
      class="country-selector"
      [required]="true"
      [requiredErrorMessage]="'Country is required'"
      [showRequiredErrorMessage]="true"
      [appearance]="'outline'"
      [lang]="'en'"
      [placeholder]="'Country'"
      (countrySelected)="setSelectedCountry('P', $event)"
    ></ng-country-select>

    <mat-form-field appearance="outline">
      <mat-label>Enter Passport number</mat-label>
      <input
        required
        matInput
        placeholder="Enter Passport number"
        formControlName="passportNumber"
      />
      @if (passportForm()?.get('passportNumber')?.errors &&
      passportForm()?.get('passportNumber')?.touched) {
      <mat-error>Please enter a valid passport number</mat-error>
      }
    </mat-form-field>

    <div class="date-container">
      <mat-form-field class="date-picker-field" appearance="outline">
        <mat-label>Expiry date</mat-label>
        <input
          required
          matInput
          placeholder="YYYY/MM/DD"
          type="text"
          inputmode="numeric"
          formControlName="expiryDate"
          [matDatepicker]="expiryPicker"
          [minlength]="10"
          [maxlength]="10"
          (keyup)="formatDate($event)"
        />
        <mat-datepicker-toggle matSuffix [for]="expiryPicker"></mat-datepicker-toggle>
        <mat-datepicker #expiryPicker></mat-datepicker>

        @if (passportForm()?.get('expiryDate')?.hasError('notAValidDate') &&
        passportForm()?.get('expiryDate')?.touched) {
        <mat-error>Invalid date</mat-error>
        } @else if (passportForm()?.get('expiryDate')?.errors &&
        passportForm()?.get('expiryDate')?.touched) {
        <mat-error>Please enter a future date</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="date-picker-field" appearance="outline">
        <mat-label>Date of birth</mat-label>
        <input
          required
          matInput
          placeholder="YYYY/MM/DD"
          type="text"
          inputmode="numeric"
          [matDatepicker]="dobPicker"
          formControlName="dob"
          [minlength]="10"
          [maxlength]="10"
          (keyup)="formatDate($event)"
        />
        <mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
        <mat-datepicker #dobPicker></mat-datepicker>

        @if (passportForm()?.get('dob')?.hasError('notAValidDate') &&
        passportForm()?.get('dob')?.touched) {
        <mat-error>Invalid date</mat-error>
        } @else if (passportForm()?.get('dob')?.hasError('notAdult') &&
        passportForm()?.get('dob')?.touched) {
        <mat-error>You need to be +18</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  }

  <!-- Asylum Form -->
  @if (asylumForm()) {
  <div class="asylum-form form" [formGroup]="asylumForm()!">
    <ng-country-select
      class="country-selector"
      [required]="true"
      [requiredErrorMessage]="'Country is required'"
      [showRequiredErrorMessage]="true"
      [appearance]="'outline'"
      [placeholder]="'Country'"
      [lang]="'en'"
      (countrySelected)="setSelectedCountry('A', $event)"
    ></ng-country-select>

    <mat-form-field appearance="outline">
      <mat-label>Enter Asylum number</mat-label>
      <input matInput placeholder="Enter Asylum number" formControlName="asylumNumber" />
      @if (asylumForm()?.get('asylumNumber')?.errors && asylumForm()?.get('asylumNumber')?.touched)
      {
      <mat-error>Please enter a valid asylum number</mat-error>
      }
    </mat-form-field>

    <div class="date-container">
      <mat-form-field class="date-picker-field" appearance="outline">
        <mat-label>Expiry date</mat-label>
        <input
          required
          matInput
          placeholder="YYYY/MM/DD"
          type="text"
          inputmode="numeric"
          formControlName="expiryDate"
          [matDatepicker]="expiryPickerAsylum"
          [minlength]="10"
          [maxlength]="10"
          (keyup)="formatDate($event)"
        />
        <mat-datepicker-toggle matSuffix [for]="expiryPickerAsylum"></mat-datepicker-toggle>
        <mat-datepicker #expiryPickerAsylum></mat-datepicker>
        @if (asylumForm()?.get('expiryDate')?.hasError('notAValidDate') &&
        asylumForm()?.get('expiryDate')?.touched) {
        <mat-error>Invalid date</mat-error>
        } @else if (asylumForm()?.get('expiryDate')?.errors &&
        asylumForm()?.get('expiryDate')?.touched) {
        <mat-error>Please enter a future date</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="date-picker-field" appearance="outline">
        <mat-label>Date of birth</mat-label>
        <input
          required
          matInput
          placeholder="YYYY/MM/DD"
          type="text"
          inputmode="numeric"
          formControlName="dob"
          [matDatepicker]="dobPickerAsylum"
          [minlength]="10"
          [maxlength]="10"
          (keyup)="formatDate($event)"
        />
        <mat-datepicker-toggle matSuffix [for]="dobPickerAsylum"></mat-datepicker-toggle>
        <mat-datepicker #dobPickerAsylum></mat-datepicker>
        @if (asylumForm()?.get('dob')?.hasError('notAValidDate') &&
        asylumForm()?.get('dob')?.touched) {
        <mat-error>Invalid date</mat-error>
        } @else if (asylumForm()?.get('dob')?.hasError('notAdult') &&
        asylumForm()?.get('dob')?.touched) {
        <mat-error>You need to be +18</mat-error>
        }
      </mat-form-field>
    </div>
  </div>
  }
</div>
